import styled from 'styled-components';

export const EmailContainer = styled.div`
  padding: 20px;
  background: var(--white);
  border: 1px solid var(--grey-3);
  box-sizing: border-box;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  border-radius: 8px;

  .slick-list {
    overflow: hidden;
  }
  .subscribe-form--label {
    font-family: var(--font-family-heading);
    font-size: var(--font-size-p-md);
    font-weight: var(--font-weight-700);
    line-height: 24px;
  }
  .signup-form--form {
    padding: 0px !important;

    .signup-form--submit-button {
      width: 100% !important;
      font-size: var(--font-size-16);
    }
  }

  .sidebar--subscribe-marketo-form {
    box-shadow: none !important;
    padding: 0;

    .data-layer-form {
      flex-direction: column;

      .text-field-wrapper .text-field-input {
        width: 100%;
      }

      button {
        box-shadow: none;
      }
    }
  }
`;
